import React, { useId, useState } from "react";

export default function CollapsibleSection({ title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();

  return (
    <div className="collapse">
      <button
        type="button"
        className="collapse-trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={panelId}
      >
        <span className="collapse-title">{title}</span>
        <span className={`collapse-icon ${open ? "open" : ""}`} aria-hidden="true">
          ▾
        </span>
      </button>

      <div
        id={panelId}
        className={`collapse-panel ${open ? "open" : ""}`}
        role="region"
      >
        {children}
      </div>
    </div>
  );
}
